// src/components/Planos.js
import React from 'react';
import './Planos.css';

const Planos = () => {
  const planos = [
    { 
      titulo: 'Plano Ultra', 
      preco: 'R$ 199', 
      animais: 'Até 100 animais',
      caracteristicas: [
        'Rastreabilidade individual',
        'Controle vacinal digital',
        'Alertas automáticos',
        'Relatórios mensais',
        'Suporte por WhatsApp',
        'Backup em nuvem',
        'Vendas dentro da plataforma',
        'Chat entre produtores'
      ],
      popular: false
    },
    { 
      titulo: 'Plano Mega', 
      preco: 'R$ 399', 
      animais: '101-300 animais',
      caracteristicas: [
        'Rastreabilidade individual',
        'Controle vacinal digital',
        'Alertas automáticos',
        'Relatórios mensais',
        'Suporte por WhatsApp',
        'Backup em nuvem',
        'Vendas dentro da plataforma',
        'Chat entre produtores'
      ],
      popular: true
    },
    { 
      titulo: 'Plano Hiper', 
      preco: 'R$ 900', 
      animais: '301-800 animais',
      caracteristicas: [
        'Rastreabilidade individual',
        'Controle vacinal digital',
        'Alertas automáticos',
        'Relatórios mensais',
        'Suporte por WhatsApp',
        'Backup em nuvem',
        'Vendas dentro da plataforma',
        'Chat entre produtores'
      ],
      popular: false
    }
  ];

  const vantagens = [
    { icon: 'fas fa-arrows-alt-h', titulo: 'Flexibilidade', descricao: 'Altere seu plano conforme seu rebanho cresce' },
    { icon: 'fas fa-shield-alt', titulo: 'Segurança', descricao: 'Seus dados protegidos com criptografia de ponta' },
    { icon: 'fas fa-times-circle', titulo: 'Sem Fidelidade', descricao: 'Cancele quando quiser sem multas' }
  ];

  return (
    <section id="planos" className="section planos">
      <div className="container">
        <span className="section-eyebrow">Investimento</span>
        <h2 className="section-title">Planos de Assinatura</h2>
        <p className="section-subtitle">Escolha o plano ideal para o tamanho do seu rebanho e tenha controle total sobre a saúde dos seus animais.</p>
        
        <div className="planos-container">
          {planos.map((plano, index) => (
            <div key={index} className={`plano-card ${plano.popular ? 'plano-popular' : ''}`}>
              <h3 className="plano-titulo">{plano.titulo}</h3>
              <div className="plano-preco">{plano.preco} <span>/mês</span></div>
              <div className="plano-animais">{plano.animais}</div>
              <ul className="plano-caracteristicas">
                {plano.caracteristicas.map((caracteristica, idx) => (
                  <li key={idx} className="plano-caracteristica">{caracteristica}</li>
                ))}
              </ul>
              <a href="#contato" className="btn">Escolher Plano</a>
              <div className="plano-taxa">* R$ 15 por microchip de rastreabilidade (pagamento único)</div>
            </div>
          ))}
        </div>
        
        {/* Plano Plus Personalizado */}
        <div className="plano-plus-container">
          <h2 className="plano-plus-titulo">Plano Plus</h2>
          <p className="plano-plus-descricao">Para grandes produtores com rebanhos acima de 800 animais. Oferecemos uma solução personalizada com funcionalidades exclusivas.</p>
          
          <div className="plano-plus-beneficios">
            <div className="plano-plus-beneficio">
              <i className="fas fa-cogs"></i>
              <span>Planejamento personalizado</span>
            </div>
            <div className="plano-plus-beneficio">
              <i className="fas fa-headset"></i>
              <span>Suporte técnico dedicado</span>
            </div>
            <div className="plano-plus-beneficio">
              <i className="fas fa-chart-line"></i>
              <span>Relatórios analíticos avançados</span>
            </div>
            <div className="plano-plus-beneficio">
              <i className="fas fa-tools"></i>
              <span>Integrações customizadas</span>
            </div>
          </div>
          
          <a href="#contato" className="btn btn-secondary">Solicitar Orçamento Personalizado</a>
        </div>
        
        <div className="planos-vantagens">
          {vantagens.map((vantagem, index) => (
            <div key={index} className="vantagem-item">
              <i className={`${vantagem.icon} vantagem-icon`}></i>
              <h4>{vantagem.titulo}</h4>
              <p>{vantagem.descricao}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Planos;